// React imports
import { createContext } from 'react'

export const LocalContext = createContext()
